export default {
  title: 'Info',
  sections: {
    work_schedule: 'Openingstijden: online bestellen',
    delivery_schedule: 'Bezorgtijden',
    delivery_costs: 'Bezorgkosten',
    website: 'Website',
  },
  labels: {
    delivery_fees: 'Min. bedrag - {{threshold}}, Kosten - {{fee}}',
  },
};
